export default __webpack_public_path__ + "static/media/lm_placeholder.cbdc5e5e.jpg";